/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'
import { MarksProceduresApi as Api } from '@/api/resources/Marks'

import { Fabric } from '@/store/createCrudModule'
import { BaseApiParams } from '@/typings/common'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

type Payload =
  {
      file: File;
      procedure: {
        id: string;
        name: string;
        session: string;
        subject: string;
        parallel: string;
      };
      save_answers: boolean;
      is_remote: boolean;
      is_gramotnost: boolean;
      meta: string;
    };

export class PublicationsTransformerParams extends TransformerParams {
  public create(payload: Payload, rawParams?: BaseApiParams) {
    const params = {
      file: payload.file,
      procedure_id: payload.procedure.id,
      procedure_name: payload.procedure.name,
      session_code: payload.procedure.session,
      subject_code: payload.procedure.subject,
      parallel_code: payload.procedure.parallel,
      save_answers: !!payload.save_answers,
      is_remote: !!payload.is_remote,
      is_gramotnost: !!payload.is_gramotnost,
      meta: payload.meta,
      ...this.getParamsWithDefaults(rawParams),
    }

    const options = {}
    return { params, options }
  }
}

export class PublicationsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationsTransformerParams();

  public create(payload: BaseApiParams, rawParams: BaseApiParams) {
    const { params, options } = this.transformerParams.create(
      payload as Payload,
      rawParams,
    )

    return this.api
      .createProcedure(params, options)
      .then((response) => this.transformerData.create(response, rawParams))
  }
}
